export const FIXED_EID_LENGTH = 6;
